var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-label": "Opens in a new window"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12v5a1 1 0 01-1 1H1a1 1 0 01-1-1V7a1 1 0 011-1h5.026H6",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 6h6v4H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    x: 6,
    width: 12,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6 0h12v4H6z"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-label='Opens in a new window'%3E %3Cg transform='translate(3 3)' fill='none' fill-rule='evenodd'%3E %3Cpath d='M12 12v5a1 1 0 01-1 1H1a1 1 0 01-1-1V7a1 1 0 011-1h5.026H6' stroke='%23000' stroke-width='2' stroke-linejoin='round'/%3E %3Cpath fill='%23000' d='M0 6h6v4H0z'/%3E %3Crect stroke='%23000' stroke-width='2' stroke-linejoin='round' x='6' width='12' height='12' rx='1'/%3E %3Cpath fill='%23000' d='M6 0h12v4H6z'/%3E %3C/g%3E %3C/svg%3E";
export { SvgNewWindow as ReactComponent };